import React, { Component } from 'react';
import DashboardLayout from '../../layouts/DashboardLayout';

export default class CorrectorHome extends Component {
  render() {
    return (
      <DashboardLayout>
        <h1>This is Corrector Dashboard is Coming Soon..!</h1>
      </DashboardLayout>
    );
  }
}
